import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="loading-screen">
      <div style={{ background: "#fff", borderRadius: 12, padding: "32px 28px", maxWidth: 400, textAlign: "center" }}>
        <h2 style={{ margin: "0 0 12px", color: "#1a1a2e" }}>Page Not Found</h2>
        <p style={{ color: "#6b7280", fontSize: 14, margin: "0 0 20px" }}>
          The page you're looking for doesn't exist or you don't have permission to view it.
        </p>
        <button
          onClick={() => navigate("/")}
          style={{ padding: "10px 24px", background: "#1a1a2e", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 14 }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
